import { getSize } from '@lib/common';
import styled from '@xstyled/styled-components';

export const StyledSpaceLayout = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

export const StyledTopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${getSize('padding12')};
  flex-shrink: 0;
`;

export const StyledSearchWrapper = styled.div`
  flex: 0 0 50%;
`;

export const StyledFilterBarWrapper = styled.div`
  margin-top: ${getSize('padding12')};
  margin-bottom: ${getSize('padding20')};
  flex-shrink: 0;
`;

export const StyledTableAssignmentContainer = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin-top: ${getSize('padding24')};
`;

export const EmptyListArea = styled.div`
  width: 100%;
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
